var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("content-container", [
        _c("article", { staticClass: "add-new-item" }, [
          _c("p", { staticClass: "add-new-item-title" }, [
            _vm._v("Special Item"),
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-top": "10px" } }, [
            _c("span", { staticClass: "ghost-item-title" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newItemName,
                    expression: "newItemName",
                  },
                ],
                ref: "itemInput",
                staticClass: "ghost-item-title-box",
                staticStyle: { width: "145px", "margin-left": "10px" },
                attrs: {
                  title: "Name of new item",
                  placeholder: "Name Of Item",
                  type: "text",
                  name: "gname",
                  maxlength: "60",
                },
                domProps: { value: _vm.newItemName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.newItemName = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "ghost-item-price" }, [
              _vm._v("\n\t\t\t\t\t$\n\t\t\t\t\t"),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.newItemPrice,
                    expression: "newItemPrice",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "ghost-item-price-box",
                staticStyle: { width: "45px" },
                attrs: {
                  type: "text",
                  name: "gprice",
                  title: "Price of new item",
                  maxlength: "6",
                },
                domProps: { value: _vm.newItemPrice },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.newItemPrice = $event.target.value.trim()
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu-item-description",
              staticStyle: { margin: "10px" },
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.whofor,
                    expression: "whofor",
                  },
                ],
                staticClass: "ghost-textarea",
                attrs: {
                  title: "Who is this for?",
                  placeholder: "Who is this for?",
                  rows: "1",
                  cols: "20",
                },
                domProps: { value: _vm.whofor },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.whofor = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "menu-item-description",
              staticStyle: { margin: "10px" },
            },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.specInstructions,
                    expression: "specInstructions",
                  },
                ],
                staticClass: "ghost-textarea",
                attrs: {
                  title: "Special Instructions for " + _vm.restName,
                  placeholder: "Special Instructions for " + _vm.restName,
                  rows: "2",
                  cols: "20",
                },
                domProps: { value: _vm.specInstructions },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.specInstructions = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "menu-item-order" }, [
            _c(
              "label",
              { staticClass: "item-order-label", attrs: { for: "item-order" } },
              [_vm._v("Set Item Qty:")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newItemQty,
                  expression: "newItemQty",
                },
              ],
              attrs: { type: "text", id: "item-order", title: "item order" },
              domProps: { value: _vm.newItemQty },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.newItemQty = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.maxToolTip,
                  expression: "maxToolTip",
                },
              ],
              staticClass: "fas fa-angle-double-up",
              on: {
                click: function ($event) {
                  return _vm.increaseQuantity()
                },
              },
            }),
            _vm._v(" "),
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.minToolTip,
                  expression: "minToolTip",
                },
              ],
              staticClass: "fas fa-angle-double-down",
              on: {
                click: function ($event) {
                  return _vm.decreaseQuantity()
                },
              },
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.addItemToolTip,
                  expression: "addItemToolTip",
                },
              ],
              staticClass: "menu-item-addbtn",
              attrs: {
                type: "image",
                name: "submit",
                src: _vm.$CDN + "/style/btn-add.gif",
                title: "add new item to group",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.submit()
                },
              },
            }),
            _vm._v(" "),
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSpinner,
                  expression: "showSpinner",
                },
              ],
              staticClass: "fas fa-spinner fa-spin fa-3x",
            }),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }